/**
 * Composable for branding-related utilities
 * Provides methods to customize text with installation-specific branding
 */
import { computed } from 'vue';
import { useMapGetter } from 'dashboard/composables/store.js';

export function useBranding() {
  const globalConfig = useMapGetter('globalConfig/get');

  // AI 产品名始终派生自实例名称，品牌设置更新后无需维护第二份名称配置。
  const aiName = computed(
    () => `${globalConfig.value?.installationName || 'Chatwoot'} AI`
  );

  /**
   * Replaces "Chatwoot" in text with the installation name from global config
   * @param {string} text - The text to process
   * @returns {string} - Text with "Chatwoot" replaced by installation name
   */
  const replaceInstallationName = text => {
    if (!text) return text;

    const installationName = globalConfig.value?.installationName;
    if (!installationName) return text;

    return text.replace(/Chatwoot/g, installationName);
  };

  return {
    aiName,
    replaceInstallationName,
  };
}
